/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private httpClient: HttpClient) {}

  getUserAccess(userId: number, userType: string): Observable<any> {
    return this.handleResponse(this.httpClient.get(`${environment.apiHostname}/v1/users/access/${userId}/${userType}`));
  }

  private handleResponse(methodCallResponse: Observable<object>) {
    return methodCallResponse.pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }
}
